"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("path", {
      d: "M7.206 4.532V3.456c0-.44-.552-.664-.874-.352L3.986 5.382c-.096.09-.15.217-.15.35 0 .13.054.258.15.35l2.346 2.276c.322.313.874.094.874-.347V6.904c1.418.028 2.33 1.022 3.295 2.8-.236-1.73-.297-3.743-1.48-4.617-.775-.572-1.392-.543-1.814-.554z",
      fill: "currentColor",
      fillRule: "nonzero"
    }), (0, _jsxRuntime.jsx)("path", {
      d: "M2.91 5.347c-.103.1-.163.24-.162.387 0 .145.06.285.166.385.622.59 1.743 1.658 1.743 1.658.168.164.172.433.01.6-.164.17-.434.174-.602.01l-2.42-2.345c-.08-.08-.128-.188-.128-.303 0-.114.045-.224.126-.304l2.37-2.342c.167-.164.436-.163.6.004.166.167.164.436-.003.6l-1.7 1.65z",
      fill: "currentColor",
      fillRule: "nonzero"
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=ReplyAll.js.map